import moment from 'moment'
import { Select, Icon } from '@driftt/tide-core-legacy'
import Tag from 'shared-web/src/components/Tag'
import { GenerateSelectOptions } from './RowGenerator'

const OutboundPriorityInput = (playbook, playbookSizes, onChange) => {
  const priorityList = GenerateSelectOptions(1, playbookSizes.totalOutboundPlaybooks)

  const changePriority = (e) => {
    onChange(e, playbook)
  }

  return (
    <div>
      <Select value={playbook.priority} 
              options={priorityList} 
              onChange={changePriority} 
              clearable={false} 
              className="set-priorities-select"
      />
    </div>
  )
}

const NameCell = playbook => (
  <div className="playbook-priority-list-name-cell">
    <div className="playbook-priority-list-name">
      {playbook.name}
    </div>
    <Tag className="playbook-table-row-name-tag outbound-tag" tag={{ name: 'Outbound' }} />
  </div>
)

const LastUpdated = (playbook, orgUsers) => {
  const lastUpdatedBy = orgUsers.get(playbook.updatedAuthorId || playbook.createdAuthorId)

  return (
    <div className="playbook-table-row-updated">
      <div>
        {moment(playbook.updatedAt).format('ll')}
      </div>
      {lastUpdatedBy &&
        <div className="playbook-table-row-last-update-by">by {(lastUpdatedBy.name || lastUpdatedBy.email)}</div>
      }
      <div className="playbook-table-row-type-callout callout-outbound">
        <Icon name="target-2" />
        <div className="playbook-table-row-type-callout-text">
          Outbound playbooks are always  highest priority.
        </div>
      </div>
    </div>
  )
}

export const OutboundRowFormatter = (playbook, playbookSizes, onPriorityChange, orgUsers) => ([
  { content: OutboundPriorityInput(playbook, playbookSizes, onPriorityChange) },
  { content: NameCell(playbook) },
  { content: LastUpdated(playbook, orgUsers) }
])



// WEBPACK FOOTER //
// ./src/scripts/components/PlaybookList/Prioritize/PlaybookPrioritiesTable/OutboundRowFormatter.js